import api from "../../api/client";
import { API_ROUTE } from "../../api/endpoints";

export async function getPrediction(enterprise = "ACM") {
  const { data } = await api.get(API_ROUTE.GET_PREDICTION(enterprise));
  return data;
}
